import { Component, Input, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { VehicleDetailsQuery } from 'src/sell/lib/details/interfaces/vehicle-details.query';
import { DetailsQueries } from 'src/sell/lib/details/queries/details.queries';
import { CurrencyFormatService } from 'smartauction-frontend-micro-library';
import {
  DetailsState,
  GetInventoryItemDistance,
  LaunchDarklyService,
  Organization,
} from 'remarketing-angular-library';
import { DatalistItemComponent } from 'remarketing-ui-components-lib';
import { NgClass, AsyncPipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-vehicle-details',
    templateUrl: './auto-vision-vehicle-details.component.html',
    styleUrls: ['./auto-vision-vehicle-details.component.scss'],
    imports: [DatalistItemComponent, NgClass, AsyncPipe, DecimalPipe]
})
export class AutoVisionVehicleDetailsComponent extends SaComponent implements OnInit {
  @Input() showHeading = true;
  @Select(DetailsQueries.vehicleDetails) details$: Observable<VehicleDetailsQuery>;
  organization: Organization;
  autoVisionVehicleDetailsTransltions = {
    vehicleDetails: '',
    seller: '',
    odometer: '',
    vehicleLocation: '',
    distance: '',
    titleState: '',
    type: '',
    exterior: '',
    interior: '',
    hits: '',
    sellerComments: '',
    distanceUnit: ''
  };

  get isMsrpEnabled() {
    return this.launchDarklyService.getFeatureFlag('msrpEnabled', false);
  }

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly currencyFormatService: CurrencyFormatService,
    private readonly launchDarklyService: LaunchDarklyService,
    private readonly store: Store
  ) {
    super();
  }

  ngOnInit(): void {
    this.getTranslations();
    this.getDistance();
  }

  getDistance() {
    const inventoryItem = this.store.selectSnapshot(DetailsState.inventoryItem);
    this.store
      .select(state => state.org)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(org => {
        this.organization = org.organization;
      });
    // Distance value requires inventoryItemUuid and organization to update state.
    this.store.dispatch(new GetInventoryItemDistance(inventoryItem?.inventoryItemUuid, this.organization));
  }

  getOdometer(vehicle) {
    return vehicle.odometer + ' ' + this.autoVisionVehicleDetailsTransltions.distanceUnit;
  }

  formatCurrency(currency) {
    return this.currencyFormatService.formatCurrency(currency, false).replaceAll('-', '');
  }

  getTranslations() {
    const keyParams = {
      'sellModule.details.vehicleDetail': {},
      'common': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(
        translate => {
          this.autoVisionVehicleDetailsTransltions.vehicleDetails = translate[0].vehicleDetails;
          this.autoVisionVehicleDetailsTransltions.seller = translate[0].seller;
          this.autoVisionVehicleDetailsTransltions.odometer = translate[0].odometer;
          this.autoVisionVehicleDetailsTransltions.vehicleLocation = translate[0].vehicleLocation;
          this.autoVisionVehicleDetailsTransltions.distance = translate[0].distance;
          this.autoVisionVehicleDetailsTransltions.titleState = translate[0].titleState;
          this.autoVisionVehicleDetailsTransltions.type = translate[0].type;
          this.autoVisionVehicleDetailsTransltions.exterior = translate[0].exterior;
          this.autoVisionVehicleDetailsTransltions.interior = translate[0].interior;
          this.autoVisionVehicleDetailsTransltions.hits = translate[0].hits;
          this.autoVisionVehicleDetailsTransltions.sellerComments = translate[0].sellerComments;
          this.autoVisionVehicleDetailsTransltions.distanceUnit = translate[1].distanceUnit;
        },
        error => {
          console.log(error);
        }
      );
  }
}
